import { Paper, Typography, Box } from '@mui/material';
import { CredentialsForm } from './CredentialsForm';
import React from 'react';

interface CredentialsComponentProps {
  email: string;
  password: string;
  loading: boolean;
  error?: string | null;
  onEmailChange: (email: string) => void;
  onPasswordChange: (password: string) => void;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  onBack: () => void;
}

export function CredentialsComponent({ email, password, loading, error, onEmailChange, onPasswordChange, onSubmit, onBack }: CredentialsComponentProps) {
  return (
    <Box
      sx={{
        marginTop: 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Paper
        elevation={2}
        sx={{
          padding: 4,
          width: '100%',
          borderRadius: 2
        }}
      >
        <Typography component="h1" variant="h4" align="center" fontWeight="600" gutterBottom>
          Sign In
        </Typography>
        <Typography variant="body1" color="text.secondary" align="center" sx={{ mb: 4 }}>
          Sign in with Email & Password
        </Typography>
        {error && (
          <Box
            sx={{
              p: 2,
              mb: 3,
              backgroundColor: 'error.light',
              borderRadius: 1,
              color: 'error.contrastText'
            }}
          >
            <Typography align="center" variant="body2">
              Authentication failed: {error}
            </Typography>
          </Box>
        )}
        <CredentialsForm
          email={email}
          password={password}
          loading={loading}
          onEmailChange={(e: React.ChangeEvent<HTMLInputElement>) => onEmailChange(e.target.value)}
          onPasswordChange={(e: React.ChangeEvent<HTMLInputElement>) => onPasswordChange(e.target.value)}
          onSubmit={onSubmit}
          onBack={onBack}
        />
      </Paper>
    </Box>
  );
}
